import { Button } from '../components/ui/Button'
import { Home, Gamepad2, Sparkles } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-surface-950 px-4">
      <div className="text-center max-w-md">
        <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-surface-200 to-surface-300 dark:from-surface-700 dark:to-surface-800 rounded-2xl flex items-center justify-center">
          <Sparkles className="w-12 h-12 text-surface-400" />
        </div>
        <h1 className="text-4xl font-bold text-surface-900 dark:text-surface-100 mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-surface-700 dark:text-surface-300 mb-4">Page Not Found</h2>
        <p className="text-surface-500 dark:text-surface-400 mb-8">
          Looks like you've wandered off the path. The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button className="flex-1" onClick={() => window.location.href = '/'}>
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <Button variant="secondary" className="flex-1" onClick={() => window.location.href = '/daily'}>
            <Gamepad2 className="w-4 h-4 mr-2" />
            Play Daily
          </Button>
        </div>
      </div>
    </div>
  )
}